var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M39.77,15.841c-1.1,0.482-2.27,0.802-3.49,0.956c1.256-0.749,2.215-1.927,2.664-3.347 c-1.17,0.697-2.463,1.191-3.84,1.466C33.992,13.732,32.408,13,30.68,13c-3.352,0-6.05,2.722-6.05,6.057 c0,0.479,0.04,0.941,0.14,1.382c-5.034-0.246-9.489-2.658-12.482-6.335c-0.522,0.907-0.829,1.944-0.829,3.061 c0,2.098,1.081,3.957,2.69,5.033c-0.973-0.019-1.928-0.302-2.736-0.745c0,0.018,0,0.042,0,0.066c0,2.941,2.099,5.387,4.852,5.949 c-0.493,0.135-1.029,0.199-1.587,0.199c-0.388,0-0.779-0.021-1.146-0.103c0.784,2.397,3.011,4.16,5.658,4.218 c-2.06,1.612-4.676,2.583-7.508,2.583c-0.497,0-0.974-0.022-1.449-0.083C12.913,36.013,16.092,37,19.52,37 c11.144,0,17.236-9.23,17.236-17.232c0-0.268-0.01-0.526-0.021-0.783C37.936,18.133,38.945,17.067,39.77,15.841z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.3eb7297e9d9f6a31c86a14735e619765.svg";
export { ForwardRef as ReactComponent };